"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
var Box_1 = __importDefault(require("../Box"));
var ColorBox = function (_a) {
    var color = _a.color, label = _a.label, isSemantic = _a.isSemantic, bold = _a.bold;
    var _b = __read(label.split(' ('), 2), mainLabel = _b[0], subLabel = _b[1];
    return (react_1.default.createElement(Box_1.default, null,
        react_1.default.createElement(styles_1.Color, { color: color, label: label, isSemantic: isSemantic }),
        react_1.default.createElement(styles_1.ColorLabel, { variant: (label === null || label === void 0 ? void 0 : label.includes('Primary Brand Color')) ? 'h5' : 'body2', label: label, gutterBottom: true }, bold ? (react_1.default.createElement(react_1.default.Fragment, null,
            mainLabel.split('/').map(function (part, index) { return (react_1.default.createElement(styles_1.BoldText, { key: index },
                part,
                index < mainLabel.split('/').length - 1 && '/')); }),
            subLabel && react_1.default.createElement(styles_1.NormalText, null,
                "(",
                subLabel,
                ")"))) : (react_1.default.createElement("span", null, label)))));
};
exports.default = ColorBox;
//# sourceMappingURL=ColorBox.js.map